app.directive("editOtherCrecheVisits", ['AuthService', function(AuthService) {
    return ({
        restrict: "A",
        link: function link($scope, element, attributes) {
            var forbidden = !AuthService.editOtherCrecheVisits();
            element[0].disabled = forbidden;
        }
    })
}]);